import {MeasureChart} from "@components/measure-chart";
import {Card, Stack, SxProps, Theme, Typography} from "@mui/material";
import {MeasureMap} from ".";
import {Sensor} from "@core/model/Sensor";
import {renderAssetTypeIcon} from "@util";

const MonitoringHorizontal = ({
  selected,
  measureMap,
  limit,
  sx,
}: {
  selected: Sensor[];
  measureMap: MeasureMap;
  limit: number;
  sx?: SxProps<Theme>;
}) => {
  return (
    <Stack direction={"row"} gap={2} overflow={"auto"} flex={1} sx={{...sx}}>
      {selected.slice(0, limit).map(s => (
        <Card
          key={`horizontal-sensor-chart-${s.id}`}
          className="chart-container"
          variant={selected.length === 1 ? "elevation" : "outlined"}
          sx={{
            flex: 1,
            minWidth: 300,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            "& .series-selector-container": {
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 1,
            },
          }}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            gap={1}
            pt={1}
            justifyContent={"center"}>
            <Typography variant="h6">{s.name}</Typography>{" "}
            {renderAssetTypeIcon(s.type, "small")}
          </Stack>
          <MeasureChart sensor={s} measures={measureMap[s.name] ?? []} live />
        </Card>
      ))}
    </Stack>
  );
};

export {MonitoringHorizontal};
